<main>
  <div class="testPageContainer">
    <div class="bolt-container">
      <h1>
        IAM Bypass
      </h1>
      @if (showError) {
        <bolt-notification>Come on! Fill out the whole form lazy!</bolt-notification>
      }
      @if (showServiceError) {
        <bolt-notification>{{serviceErrMsg}}</bolt-notification>
      }
      <div class="iamBypassForm">
        <form [formGroup]="iamBypassForm">
          <div class=" bolt-row select-style bolt-space-bottom-lg nw-form-control">
            <div class="bolt-col-md-5">
              <bolt-textfield name="usernameText"
                ngDefaultControl
                formControlName="usernameText"
                label="Username"
                id="usernameText"
                required>
                <bolt-contextual-help slot="help"
                  type="push"
                  heading="Did you know?">
                  This question is required and if left unanswered, the first offense is punishable up
                  to 4 years in prison!
                </bolt-contextual-help>
              </bolt-textfield>
            </div>
          </div>
          <div class=" bolt-row select-style bolt-space-bottom-lg nw-form-control">
            <div class="bolt-col-md-5">
              <div class="historyList">
                @for (historyItem of historyList; track historyItem) {
                  <div class="historyListItem"
                    >
                    <a href="#"
                      (click)="prefill(historyItem)">
                      {{historyItem}}
                    </a>
                    <a class="deleteLink"
                      href="#"
                      (click)="deleteItem(historyItem)">
                      <bolt-icon color="cherryRed"
                        name="xmark-circle"
                      size="sm"></bolt-icon>
                    </a>
                    <br />
                  </div>
                }
              </div>
            </div>
          </div>
          <div class=bolt-body-copy-md><strong>User IDs</strong><button (click)="toggleTable()"
          class="toggle-button">
          <bolt-icon [name]="isTableVisible ? 'chevron-up' : 'chevron-down'"
          size="lg"></bolt-icon>
        </button>
      </div>
      @if (isTableVisible) {
        <div
          class="bolt-table bolt-table-vibrantBlue bolt-table-fit-content">
          <ng-template #renderPolicyDetails
            let-policyDetails>
            @for (item of policyDetails | keyvalue: originalOrder; track item) {
              <div  style="font-size: .7em">
                @if (item.key === 'lastName' || item.key === 'dob' || item.key === 'zip' || item.key === 'autoPolicyNumber' || item.key === 'additionalDetails' || ( item.key === 'propertyPolicyNumber' || item.key === 'condoPolicyNumber')) {
                  <span
                    >
                    <strong>{{ item.key }}:</strong> {{ item.value }}
                  </span>
                }
                @if (item.key !== 'lastName' && item.key !== 'dob' && item.key !== 'zip' && item.key !== 'autoPolicyNumber' && item.key !== 'additionalDetails' && item.key !== 'propertyPolicyNumber') {
                  <span
                    >
                    {{ item.key }}: {{ item.value }}
                  </span>
                }
              </div>
            }
          </ng-template>
          <table>
            <thead>
              <tr>
                <th id="userid"
                scope="col">User id</th>
                <th id="policyDetails"
                scope="col">Policy details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th class="bolt-table-sub-head"
                  id="sub1vibrantblue"
                colspan="2">Auto</th>
              </tr>
              @for (user of autoUsers; track user) {
                <tr>
                  <td headers="userid">
                    <a href="#"
                      (click)="prefill(user.userId)">
                      {{ user.userId }}
                    </a>
                  </td>
                  <td headers="policyDetails">
                    <ng-container
                    *ngTemplateOutlet="renderPolicyDetails; context: { $implicit: user.policyDetails }"></ng-container>
                  </td>
                </tr>
              }
              <tr>
                <th class="bolt-table-sub-head"
                  id="sub1vibrantblue"
                colspan="2">Property</th>
              </tr>
              @for (user of propertyUsers; track user) {
                <tr>
                  <td headers="userid">
                    <a href="#"
                      (click)="prefill(user.userId)">
                      {{ user.userId }}
                    </a>
                  </td>
                  <td headers="policyDetails">
                    <ng-container
                    *ngTemplateOutlet="renderPolicyDetails; context: { $implicit: user.policyDetails }"></ng-container>
                  </td>
                </tr>
              }
              <tr>
                <th class="bolt-table-sub-head"
                  id="sub1vibrantblue"
                colspan="2">Combo</th>
              </tr>
              @for (user of comboUsers; track user) {
                <tr>
                  <td headers="userid">
                    <a href="#"
                      (click)="prefill(user.userId)">
                      {{ user.userId }}
                    </a>
                  </td>
                  <td headers="policyDetails">
                    <ng-container
                    *ngTemplateOutlet="renderPolicyDetails; context: { $implicit: user.policyDetails }"></ng-container>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      &nbsp;
      <div class=" bolt-row select-style bolt-space-bottom-lg nw-form-control">
        <div class="bolt-col-md-5">
          <bolt-radio-group label="Environment"
            name="environment"
            ngDefaultControl
            formControlName="environment"
            horizontal
            id="environmentGroup"
            required>
            <bolt-contextual-help slot="help"
              type="push"
              heading="Did you know?">
              If you click Continue without answering this question a small child somewhere in the
              world won't get presents on their birthday?
            </bolt-contextual-help>
            <bolt-radio id="envLocalDev"
            value="LOCALDEV">LOCAL (DEV)</bolt-radio>
            <bolt-radio id="envLocalTest"
            value="LOCALTEST">LOCAL (TEST)</bolt-radio>
            <bolt-radio id="envDev"
            value="DEV">DEV</bolt-radio>
            <bolt-radio id="envTest"
            value="TEST">TEST</bolt-radio>
          </bolt-radio-group>
        </div>
      </div>
      <div class=" bolt-row select-style bolt-space-bottom-lg nw-form-control">
        <div class="bolt-col-md-5">
          <bolt-select label="CC Env #"
            name="ccEnv"
            ngDefaultControl
            formControlName="ccEnv"
            horizontal
            id="ccEnvGroup">
            <bolt-contextual-help slot="help"
              type="push"
              heading="Fact">
              This is only needed when navigating to Property Dashboard in the Legacy app. But you
              already knew that, right?
            </bolt-contextual-help>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
          </bolt-select>
        </div>
      </div>
      <bolt-button-bar>
        <bolt-button id="cancelBtn"
          (click)="cancel()"
        slot="alternate">Cancel</bolt-button>
        <bolt-button id="clearBtn"
          (click)="clear()"
        slot="cancel">Clear All History</bolt-button>
        <bolt-button id="envBtn"
          (click)="openModal()"
        slot="back">Show Environments</bolt-button>
        <bolt-button id="continueBtn"
          (click)="continue()"
          slot="forward"
        type="solid">Continue</bolt-button>
      </bolt-button-bar>
    </form>
  </div>
  @if (showWait) {
    <bolt-waiting-indicator class="bolt-space-inner-xl bolt-space-bottom-lg"
    id="waitSpinner">Preparing for glory...</bolt-waiting-indicator>
  }
  @if (showResults) {
    <div class="iamBypassResults"
      id="searchResults">
      <h2>Results</h2>
      @for (link of links; track link; let i = $index) {
        <div [id]="'linkItemBox'+i"
          class="linkItem"
          >
          <a [id]="'linkItemLink'+i"
            [href]="link.url"
          target="_blank">{{link.env}}: {{link.productType}} - {{link.agreementNumber}}</a>
        </div>
      }
    </div>
  }
</div>
</div>
<bolt-modal #environmentModal
  id="contentModal"
  type="content"
  heading="ISClaims Bucket Allocation"
  primarybutton="Close">
  <div class="bolt-table bolt-table-striped">
    <table>
      <tr>
        <th>Bucket</th>
        <th>Branch</th>
      </tr>
      @for (env of environmentList; track env; let i = $index) {
        <tr>
          <td><b>{{env.name}}</b></td>
          <td>
            {{env.branch}} @if (env.commitLink !== undefined) {
            <span>
              <a target="_blank"
                class="commit-link"
              [href]="env.commitLink">( latest commit )</a>
            </span>
          }
        </td>
      </tr>
    }
  </table>
</div>
</bolt-modal>
<div id="cancelClaimModal">
  <is-cancel-modal></is-cancel-modal>
</div>
</main>
